export default __webpack_public_path__ + "static/media/polaroid_CityCollegePlymouth.aa721565.png";